import React, { useEffect, useState } from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import topback from "../images/beetitle.png";
import pdficon from "../images/pdf-icon.jpg";

function StaffNoc() {
  const [downloads, setDownloads] = useState([]);
  const RUrlmain = "http://gcbeetan.co.in/admin/downloads/"; // backend file path

  useEffect(() => {
    fetch("http://gcbeetan.co.in/admin/api/downloads.php?category=3") // 3 = Staff NOC
      .then((res) => res.json())
      .then((data) => setDownloads(data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <>
      <Header />
      <div className="section">
        <section
          className="content-section title-top"
          style={{ backgroundImage: `url(${topback})` }}
        >
          <div className="pattern-overlay">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 title-heading">
                  <h2>Staff → NOC</h2>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="container mt-4">
          {downloads.length > 0 ? (
            downloads.map((item) => (
              <div className="row mb-3" key={item.id}>
                <div className="col-2 align-self-center">
                  <img
                    className="border rounded pdficon"
                    src={pdficon}
                    alt="file icon"
                    style={{ width: "128px" }}
                  />
                </div>
                <div className="col-6 align-self-center">
                  <p className="pdfpara">
                    {item.file ? (
                      <a
                        href={`${RUrlmain}${item.file}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <strong>{item.title}</strong>
                      </a>
                    ) : (
                      <a href={item.externalurl} target="_blank" rel="noreferrer">
                        <strong>{item.title}</strong>
                      </a>
                    )}
                  </p>
                </div>
                <div className="col-2"></div>
                <div className="col-2 align-self-center">
                  <a
                    href={item.file ? `${RUrlmain}${item.file}` : item.externalurl}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-back"
                    style={{ width: "150px", height: "36px" }}
                  >
                    Download <i className="icon ion-ios-arrow-thin-down"></i>
                  </a>
                </div>
              </div>
            ))
          ) : (
            <p>No downloads available in this category.</p>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default StaffNoc;
